import { numberWithCommas } from "../../Report_common_function";
import { globalFromDate, globalSelectedMonth, globalToDate } from "../LoyaltyClaim";

function formatSelectedMonth(monthString) {
  if (!monthString) return "";

  const [year, month] = monthString.split("-");
  const date = new Date(year, month - 1);

  return date.toLocaleString("default", {
    month: "short",
    year: "numeric",
  });
}


// ==========================================================
// 🔹 MODE 1 — Invoice-wise report
// ==========================================================
export const columns_mode1 = [
  "Franchise Name",
  "Invoice Date",
  "Invoice Number",
  "Redemption Amount Per Invoice",
];

export const Rows_mode1 = (data = []) => {
  const rows = [];
  let totalRedemption = 0;

  data.forEach((element) => {
    const safe = (v) => (isNaN(v) || v === null ? 0 : Number(v));

    const redemption = safe(element.DiscountAmount);

    const row = [
      element.PartyName || element.FranchiseName || "",
      element.InvoiceDate || "",
      element.FullInvoiceNumber || "",
      numberWithCommas(redemption),
    ];

    totalRedemption += redemption;
    rows.push(row);
  });

  // ✅ Total row
  rows.push([
    { content: "Total", styles: { fontStyle: "bold", halign: "center", fontSize: 8 } },
    "",
    "",
    { content: numberWithCommas(totalRedemption.toFixed(2)), styles: { fontStyle: "bold", halign: "right", fontSize: 8 } },
  ]);

  // 🆕 Sign section
  rows.push([
    { content: "Franchise Stamp and Signature:", colSpan: 5, styles: { halign: "left", fontSize: 8, minCellHeight: 35 } },
  ]);

  return rows;
};


export const ReportHederRows_mode1 = (data = []) => {
 const formattedMonth = formatSelectedMonth(globalSelectedMonth);

  return [
    [
      {
        content: `Month: ${formattedMonth}`,
        styles: { halign: "center", fontStyle: "bold" },
      },
    ],
  ];
};

// ==========================================================
// 🔹 MODE 2 — Franchise summary report
// ==========================================================
export const columns_mode2 = [
  "Franchise Name",
  "Total Invoice Count",
  "Total Redemption Amount",
];

export const Rows_mode2 = (data = []) => {
  const rows = [];
  let totalAmount = 0;

  data.forEach((element) => {
    const safe = (v) => (isNaN(v) || v === null ? 0 : Number(v));

    const redemption = safe(element.DiscountAmount || '');
    const invoiceCount = safe(element.InvoiceCount);

    const row = [
      element.PartyName || element.FranchiseName || "",
      invoiceCount,
      numberWithCommas(redemption),
    ];

    totalAmount += redemption;
    rows.push(row);
  });

  // ✅ Total row
  rows.push([
    { content: "Total", styles: { fontStyle: "bold", halign: "center", fontSize: 8 } },
    "",
    { content: numberWithCommas(totalAmount.toFixed(2)), styles: { fontStyle: "bold", halign: "right", fontSize: 8 } },
  ]);

  // 🆕 Sign section
  rows.push([
    { content: "GM Signature:", colSpan: 3, styles: { halign: "left", fontSize: 8, minCellHeight: 35 } },
    { content: "Kedar Sir Sign:", styles: { halign: "left", fontSize: 8, minCellHeight: 35 } },
  ]);

  return rows;
};

export const ReportHederRows_mode2 = (data = []) => {

  const formattedMonth = formatSelectedMonth(globalSelectedMonth);

  return [
    [
      {
        content: `Month: ${formattedMonth}`,
        styles: { halign: "center", fontStyle: "bold" },
      },
    ],
  ];
};

// ==========================================================
// 🔹 MODE 3 — Item-wise discount report
// ==========================================================
export const columns_mode3 = [
  "Franchise Name",
  "Item Name",
  "Quantity",
  "Discount Amount",
];

export const Rows_mode3 = (data = []) => {
  const rows = [];
  let totalDiscount = 0;
  let totalQty = 0;

  data.forEach((element) => {
    const safe = (v) => (isNaN(v) || v === null ? 0 : Number(v));

    const qty = safe(element.Quantity);
    const discount = safe(element.ItemDiscountAmount ?? element.DiscountAmount);

    const row = [
      element.PartyName || element.FranchiseName || "",
      element.ItemName || "-",
      qty,
      numberWithCommas(discount),
    ];

    totalQty += qty;
    totalDiscount += discount;
    rows.push(row);
  });

  // ✅ Total row
  rows.push([
    { content: "Total", styles: { fontStyle: "bold", halign: "center", fontSize: 8 } },
    "",
    { content: numberWithCommas(totalQty.toFixed(2)), styles: { fontStyle: "bold", halign: "right", fontSize: 8 } },
    { content: numberWithCommas(totalDiscount.toFixed(2)), styles: { fontStyle: "bold", halign: "right", fontSize: 8 } },
  ]);

  // 🆕 Sign section
  rows.push([
    { content: "GM Signature:", colSpan: 3, styles: { halign: "left", fontSize: 8, minCellHeight: 35 } },
    { content: "Kedar Sir Sign:", styles: { halign: "left", fontSize: 8, minCellHeight: 35 } },
  ]);

  return rows;
};

export const ReportHederRows_mode3 = (data = []) => {
const formattedMonth = formatSelectedMonth(globalSelectedMonth);

  return [
    [
      {
        content: `Month: ${formattedMonth}`,
        styles: { halign: "center", fontStyle: "bold" },
      },
    ],
  ];
};

// ==========================================================
// 🔸 UNIVERSAL HANDLER — Get config dynamically
// ==========================================================
export function getTableConfig(mode, data = []) {
  switch (mode) {
    case 1:
      return {
        columns: columns_mode1,
        rows: Rows_mode1(data),
        headerRows: ReportHederRows_mode1(data),
      };
    case 2:
      return {
        columns: columns_mode2,
        rows: Rows_mode2(data),
        headerRows: ReportHederRows_mode2(data),
      };
    case 3:
      return {
        columns: columns_mode3,
        rows: Rows_mode3(data),
        headerRows: ReportHederRows_mode3(data),
      };
    default:
      console.warn(`⚠️ Unknown mode: ${mode}`);
      return { columns: [], rows: [], headerRows: [] };
  }
}

// Used by ReportStyle.js for header table
export const PageHeaderColumns = [{ header: "", dataKey: "text" }];
